"use client";

import { memo, useEffect } from "react";
import { trackEventWithCommonProps } from "@utils/eventTracker";
import { EventType } from "@utils/eventTracker";

interface BasePageTrackerProps {
  pageType: string;
  actionName?: string;
}

interface AdditionalProps {
  [key: string]: string | number | boolean | undefined | any;
}

interface PageTrackerProps extends BasePageTrackerProps {
  additionalProps?: AdditionalProps;
}


let lastPageViewFire: { key: string; at: number } | null = null;

const buildPageViewDedupeKey = (
  pathnameWithSearch: string,
  pageType: string,
  actionName: string | undefined,
  additionalProps: AdditionalProps
) =>
  `${pathnameWithSearch}|${pageType}|${actionName ?? ""}|${JSON.stringify(additionalProps)}`;

const PageTracker = ({
  pageType,
  actionName,
  additionalProps = {},
}: PageTrackerProps) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const pathnameWithSearch = `${window.location.pathname}${window.location.search}`;
    const dedupeKey = buildPageViewDedupeKey(
      pathnameWithSearch,
      pageType,
      actionName,
      additionalProps
    );
    const now = Date.now();
    if (
      lastPageViewFire &&
      lastPageViewFire.key === dedupeKey &&
      now - lastPageViewFire.at < 1000
    ) {
      return;
    }
    lastPageViewFire = { key: dedupeKey, at: now };

    void trackEventWithCommonProps("view", EventType.PAGE_EVENT, {
      pageType,
      additionalProps: {
        view_type: "view_page",
        view_name: actionName,
        ...additionalProps,
      },
    });
  }, []);

  return null;
};

export default memo(PageTracker);
